var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCommandHypesItem(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8874 10.2105C19.5976 10.005 19.1961 10.073 18.9906 10.3628L18.9781 10.3804C18.7725 10.6701 18.8407 11.0716 19.1304 11.2772C19.2434 11.3573 19.3733 11.3959 19.5021 11.3959C19.7035 11.3959 19.9018 11.3016 20.0273 11.1249L20.0397 11.1073C20.2453 10.8176 20.1771 10.4161 19.8874 10.2105Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4166 12.0322C18.1913 11.7575 17.786 11.7175 17.5114 11.9428C16.6177 12.6759 15.6022 13.1977 14.4931 13.4938C14.1499 13.5855 13.9459 13.938 14.0376 14.2812C14.1144 14.5689 14.3744 14.7587 14.6586 14.7587C14.7135 14.7587 14.7694 14.7516 14.8249 14.7367C16.1125 14.3929 17.2908 13.7875 18.3272 12.9374C18.6019 12.7122 18.6419 12.3068 18.4166 12.0322Z",
    fill: "url(#paint1_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.004 14.5665C29.9399 14.5665 29.0742 15.4322 29.0742 16.4962V16.8179C29.0742 19.5154 27.1101 21.7614 24.5372 22.2045C24.8732 21.7089 25.0698 21.1114 25.0698 20.4688V20.022C25.0698 18.3123 23.6788 16.9214 21.9691 16.9214C20.2593 16.9214 18.8684 18.3123 18.8684 20.022V20.4688C18.8684 21.0951 19.0556 21.6781 19.3761 22.1661C16.9042 21.6421 15.0435 19.4436 15.0435 16.8179V16.4962C15.0435 15.4322 14.1778 14.5665 13.1138 14.5665C12.0497 14.5665 11.1841 15.4322 11.1841 16.4962V16.8179C11.1841 18.1234 11.4497 19.386 11.9623 20.5526H7.58548V14.0747C7.58548 13.7875 7.39521 13.5351 7.11914 13.4563C3.68497 12.4741 1.28647 9.29452 1.28647 5.72398V5.40236C1.28647 5.04768 1.57503 4.75913 1.92971 4.75913C2.28439 4.75913 2.57294 5.04768 2.57294 5.40236V5.72398C2.57294 9.44812 5.60277 12.478 9.32691 12.478H12.4226C16.1468 12.478 19.1766 9.44812 19.1766 5.72398V5.40236C19.1766 5.04768 19.4651 4.75913 19.8198 4.75913C20.1745 4.75913 20.4631 5.04768 20.4631 5.40236V5.72398C20.4631 6.7127 20.2849 7.67852 19.9336 8.59442C19.8064 8.92607 19.9721 9.29812 20.3039 9.42535C20.6354 9.55265 21.0076 9.38676 21.1348 9.0551C21.5427 7.99158 21.7495 6.8708 21.7495 5.72398V5.40236C21.7495 4.33832 20.8839 3.47266 19.8198 3.47266C18.7558 3.47266 17.8901 4.33832 17.8901 5.40236V5.72398C17.8901 8.42145 15.926 10.6674 13.3531 11.1106C13.6891 10.615 13.8857 10.0176 13.8857 9.37505V8.92826C13.8857 7.21854 12.4947 5.82754 10.7849 5.82754C9.07522 5.82754 7.68428 7.21854 7.68428 8.92826V9.37505C7.68428 10.0012 7.87147 10.5843 8.19199 11.0722C5.7201 10.5482 3.85941 8.34967 3.85941 5.72398V5.40236C3.85941 4.33832 2.99375 3.47266 1.92971 3.47266C0.865666 3.47266 0 4.33832 0 5.40236V5.72398C0 7.78915 0.663948 9.74729 1.91999 11.3866C3.03562 12.8425 4.57714 13.9515 6.29908 14.546V21.1957C6.29908 21.5509 6.58705 21.839 6.94231 21.839H7.05977V32.2896C7.05977 32.6448 7.34774 32.9328 7.703 32.9328C8.05826 32.9328 8.34624 32.6448 8.34624 32.2896V21.839H12.6533C12.794 22.0576 12.9442 22.2716 13.1041 22.4804C13.1467 22.536 13.191 22.59 13.2348 22.6445V32.2896C13.2348 32.6448 13.5228 32.9328 13.8781 32.9328C14.2333 32.9328 14.5213 32.6448 14.5213 32.2896V23.9591C15.3977 24.6936 16.4051 25.2675 17.4832 25.6398V32.2896C17.4832 32.6448 17.7712 32.9328 18.1264 32.9328C18.4817 32.9328 18.7697 32.6448 18.7697 32.2896V25.1685C18.7697 24.8813 18.5794 24.6289 18.3033 24.5501C14.8691 23.5679 12.4706 20.3884 12.4706 16.8179V16.4962C12.4706 16.1415 12.7592 15.853 13.1138 15.853C13.4685 15.853 13.7571 16.1415 13.7571 16.4962V16.8179C13.7571 20.542 16.7869 23.5718 20.511 23.5718H23.6067C27.3309 23.5718 30.3607 20.542 30.3607 16.8179V16.4962C30.3607 16.1415 30.6493 15.853 31.004 15.853C31.3586 15.853 31.6472 16.1415 31.6472 16.4962V16.8179C31.6472 20.4543 29.1931 23.6493 25.6794 24.5876C25.3979 24.6627 25.2021 24.9177 25.2021 25.209V29.8667C25.2021 30.2219 25.4901 30.51 25.8453 30.51C26.2006 30.51 26.4886 30.2219 26.4886 29.8667V25.6894C30.3077 24.4486 32.9337 20.8695 32.9337 16.8179V16.4962C32.9337 15.4322 32.068 14.5665 31.004 14.5665ZM8.97076 8.92819C8.97076 7.92777 9.78458 7.11395 10.7849 7.11395C11.7853 7.11395 12.5992 7.92777 12.5992 8.92819V9.37498C12.5992 10.3753 11.7854 11.1892 10.7849 11.1892C9.78458 11.1892 8.97076 10.3753 8.97076 9.37498V8.92819ZM23.7833 20.4688C23.7833 21.4692 22.9695 22.283 21.9691 22.283C20.9687 22.283 20.1549 21.4692 20.1549 20.4688V20.022C20.1549 19.0217 20.9687 18.2078 21.9691 18.2078C22.9694 18.2078 23.7833 19.0217 23.7833 20.022V20.4688Z",
    fill: "url(#paint2_linear)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3011 31.835C26.1815 31.7152 26.0155 31.6465 25.8464 31.6465C25.6772 31.6465 25.5112 31.7152 25.3916 31.835C25.272 31.9546 25.2031 32.1205 25.2031 32.2897C25.2031 32.4589 25.272 32.6248 25.3916 32.7444C25.5112 32.8641 25.6772 32.933 25.8464 32.933C26.0155 32.933 26.1815 32.8641 26.3011 32.7444C26.4208 32.6248 26.4896 32.4589 26.4896 32.2897C26.4896 32.1205 26.4208 31.9546 26.3011 31.835Z",
    fill: "url(#paint3_linear)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7839 24.0566C10.4286 24.0566 10.1406 24.3447 10.1406 24.6999V32.2901C10.1406 32.6452 10.4286 32.9333 10.7839 32.9333C11.1391 32.9333 11.4271 32.6452 11.4271 32.2901V24.6999C11.4271 24.3447 11.1391 24.0566 10.7839 24.0566Z",
    fill: "url(#paint4_linear)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9753 5.27539C29.62 5.27539 29.332 5.56343 29.332 5.91863V6.71817C29.332 7.07336 29.62 7.3614 29.9753 7.3614C30.3305 7.3614 30.6185 7.07336 30.6185 6.71817V5.91863C30.6185 5.56343 30.3305 5.27539 29.9753 5.27539Z",
    fill: "url(#paint5_linear)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9753 9.10547C29.62 9.10547 29.332 9.39351 29.332 9.7487V10.5482C29.332 10.9034 29.62 11.1915 29.9753 11.1915C30.3305 11.1915 30.6185 10.9034 30.6185 10.5482V9.7487C30.6185 9.39351 30.3305 9.10547 29.9753 9.10547Z",
    fill: "url(#paint6_linear)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2904 7.58984H31.4909C31.1356 7.58984 30.8477 7.87788 30.8477 8.23308C30.8477 8.58827 31.1356 8.87632 31.4909 8.87632H32.2904C32.6457 8.87632 32.9337 8.58827 32.9337 8.23308C32.9337 7.87788 32.6457 7.58984 32.2904 7.58984Z",
    fill: "url(#paint7_linear)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4584 7.58984H27.6589C27.3036 7.58984 27.0156 7.87788 27.0156 8.23308C27.0156 8.58827 27.3036 8.87632 27.6589 8.87632H28.4584C28.8137 8.87632 29.1016 8.58827 29.1016 8.23308C29.1016 7.87788 28.8137 7.58984 28.4584 7.58984Z",
    fill: "url(#paint8_linear)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1432 0C13.788 0 13.5 0.288041 13.5 0.643236V1.44278C13.5 1.79797 13.788 2.08601 14.1432 2.08601C14.4985 2.08601 14.7865 1.79797 14.7865 1.44278V0.643236C14.7865 0.288041 14.4985 0 14.1432 0Z",
    fill: "url(#paint9_linear)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1432 3.83203C13.788 3.83203 13.5 4.12007 13.5 4.47527V5.27481C13.5 5.63 13.788 5.91804 14.1432 5.91804C14.4985 5.91804 14.7865 5.63 14.7865 5.27481V4.47527C14.7865 4.12007 14.4985 3.83203 14.1432 3.83203Z",
    fill: "url(#paint10_linear)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4584 2.31641H15.6589C15.3036 2.31641 15.0156 2.60445 15.0156 2.95964C15.0156 3.31484 15.3036 3.60288 15.6589 3.60288H16.4584C16.8137 3.60288 17.1016 3.31484 17.1016 2.95964C17.1016 2.60445 16.8137 2.31641 16.4584 2.31641Z",
    fill: "url(#paint11_linear)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6303 2.31641H11.8307C11.4755 2.31641 11.1875 2.60445 11.1875 2.95964C11.1875 3.31484 11.4755 3.60288 11.8307 3.60288H12.6303C12.9855 3.60288 13.2735 3.31484 13.2735 2.95964C13.2735 2.60445 12.9855 2.31641 12.6303 2.31641Z",
    fill: "url(#paint12_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 2.53402e-8,
    y1: 16.6558,
    x2: 32.9337,
    y2: 16.6558,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3598"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5436"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 2.53402e-8,
    y1: 16.6558,
    x2: 32.9337,
    y2: 16.6558,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3598"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5436"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 2.53402e-8,
    y1: 16.6558,
    x2: 32.9337,
    y2: 16.6558,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3598"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5436"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 2.53402e-8,
    y1: 16.6558,
    x2: 32.9337,
    y2: 16.6558,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3598"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5436"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 2.53402e-8,
    y1: 16.6558,
    x2: 32.9337,
    y2: 16.6558,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3598"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5436"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 2.53402e-8,
    y1: 16.6558,
    x2: 32.9337,
    y2: 16.6558,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3598"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5436"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: 2.53402e-8,
    y1: 16.6558,
    x2: 32.9337,
    y2: 16.6558,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3598"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5436"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear",
    x1: 2.53402e-8,
    y1: 16.6558,
    x2: 32.9337,
    y2: 16.6558,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3598"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5436"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear",
    x1: 2.53402e-8,
    y1: 16.6558,
    x2: 32.9337,
    y2: 16.6558,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3598"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5436"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear",
    x1: 2.53402e-8,
    y1: 16.6558,
    x2: 32.9337,
    y2: 16.6558,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3598"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5436"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear",
    x1: 2.53402e-8,
    y1: 16.6558,
    x2: 32.9337,
    y2: 16.6558,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3598"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5436"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear",
    x1: 2.53402e-8,
    y1: 16.6558,
    x2: 32.9337,
    y2: 16.6558,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3598"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5436"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear",
    x1: 2.53402e-8,
    y1: 16.6558,
    x2: 32.9337,
    y2: 16.6558,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3598"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5436"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommandHypesItem);
export default __webpack_public_path__ + "static/media/command-hypes-item.d423dfadbafef5a98f13effb8bcbefd2.svg";
export { ForwardRef as ReactComponent };